<template>
  <div>
    <div class="row mt-2 g-3">
      <div class="col-12 col-xl-5">
        <div class="px-3 pt-3 shadow rounded-1">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-bar-chart text-primary" />
            </span>
            <h3 class="m-0">Jumlah Laporan Tahunan</h3>
          </div>
          <p class="fs-1">{{ jumlah_laporan?.laporan_tahunan }}</p>
          <div class="row g-0 pb-3">
            <div class="col-6">
              <h5 class="m-0">{{ jumlah_laporan?.laporan_berusaha }}</h5>
              <p class="text-secondary m-lg-0">Berusaha</p>
            </div>
            <div class="col-6">
              <h5 class="m-0">{{ jumlah_laporan?.laporan_nonberusaha }}</h5>
              <p class="text-secondary m-lg-0">Nonberusaha</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-3">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-check-square text-primary" />
            </span>
            <h3 class="m-0">Selesai</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">{{ jumlah_laporan_status?.laporan_selesai }}</p>
        </div>
      </div>
    </div>

    <div class="row mt-4 g-3">
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-hourglass-2 text-primary" />
            </span>
            <h3 class="m-0">Laporan Belum Diverifikasi</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">{{ jumlah_laporan_status?.laporan_belum_verifikasi }}</p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-file-text-o text-primary" />
            </span>
            <h3 class="m-0">Laporan Sudah Diterima</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">{{ jumlah_laporan_status?.laporan_sudah_terima }}</p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-search text-primary" />
            </span>
            <h3 class="m-0">Dalam Proses Penilaian</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">{{ jumlah_laporan_status?.laporan_dalam_proses }}</p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-refresh text-primary" />
            </span>
            <h3 class="m-0">Laporan Perlu Diperbaiki</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">{{ jumlah_laporan_status?.laporan_perlu_diperbaiki }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['jumlah_laporan', 'jumlah_laporan_status'],
}
</script>
